import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { RefObject, useEffect, useRef } from 'react';

const useBodyScrollLock = <T extends HTMLElement>(trigger: boolean): RefObject<T> => {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (ref.current === null) {
      clearAllBodyScrollLocks();
      return;
    }

    if (trigger === true) {
      disableBodyScroll(ref.current);
    } else {
      enableBodyScroll(ref.current);
    }

    return () => {
      if (ref.current !== null) {
        enableBodyScroll(ref.current);
      }
    };
  }, [trigger]);

  return ref;
};

export default useBodyScrollLock;

export const useBodyScrollLockNew = (trigger: boolean): void => {
  const clearStyles = (bodyElement: HTMLBodyElement): void => {
    if (bodyElement) {
      bodyElement.style.maxHeight = bodyElement.getAttribute('data-initial-max-height') || '';
      bodyElement.style.overflow = bodyElement.getAttribute('data-initial-overflow') || '';
    }
  };

  useEffect(() => {
    const bodyElement = document.querySelector('body');
    if (trigger) {
      if (bodyElement) {
        bodyElement.style.maxHeight && bodyElement.setAttribute('data-initial-max-height', bodyElement.style.maxHeight);
        bodyElement.style.overflow && bodyElement.setAttribute('data-initial-overflow', bodyElement.style.overflow);

        bodyElement.style.maxHeight = '100vh';
        bodyElement.style.overflow = 'hidden';
      }
    } else {
      bodyElement && clearStyles(bodyElement);
    }

    return function () {
      const bodyElement = document.querySelector('body');
      bodyElement && clearStyles(bodyElement);
    };
  }, [trigger]);
};
